import React, { useRef, useState, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';

export default function TextEditor(props) {
	const editorRef = useRef(null);
	const log = () => {
		if (editorRef.current) {
			console.log(editorRef.current.getContent());
		}
	};
	console.log('TextEditor', props);

	const [
		content,
		setContent
	] = useState('');

	useEffect(() => {
		// Fetch existing data from an API or any other source
		const fetchData = async () => {
			try {
				const response = await fetch(props.endpoint);
				const data = await response.json();
				setContent(data.content); // Update the content state with existing data
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		fetchData();
	}, []);

	const handleEditorChange = (content) => {
		setContent(content);
	};

	const handleSave = async () => {
		// Access the editor instance and get the current content
		const editorContent = editorRef.current.getContent();

		try {
			// Make a POST request to create a new template
			const response = await axios.post('YOUR_API_ENDPOINT', {
				content: editorContent
			});

			// Handle the response as needed
			console.log('Template created:', response.data);
		} catch (error) {
			console.error('Error creating template:', error);
		}
		console.log('Saving content:', editorContent);
	};

	return (
		<div>
			<Editor
				apiKey={props.tinymce_api_key}
				value={props.value}
				onEditorChange={handleEditorChange}
				onInit={(evt, editor) => (editorRef.current = editor)}
				init={{
					height: props.height,
					menubar: true,
					plugins: [
						'advlist',
						'autolink',
						'lists',
						'link',
						'image',
						'charmap',
						'preview',
						'anchor',
						'searchreplace',
						'visualblocks',
						'fullscreen',
						'insertdatetime',
						'media',
						'table',
						'code',
						'help',
						'wordcount'
					],
					toolbar:
						'|undo redo | blocks | ' +
						'bold italic forecolor | alignleft aligncenter ' +
						'alignright alignjustify | bullist numlist outdent indent | ' +
						'removeformat | code | preview | mybutton | help',
					content_style:
						'body { font-family:Helvetica,Arial,sans-serif; font-size:14px; }',
					setup: function(editor) {
						var items = [
							{
								type: 'menuitem',
								text: 'Name',
								onAction: function() {
									editor.insertContent('<span> {{name}}</span>');
								}
							},
							{
								type: 'menuitem',
								text: 'Status',
								onAction: function() {
									editor.insertContent('<span> {{status}}</span>');
								}
							},
							{
								type: 'menuitem',
								text: 'Assessment Score',
								onAction: function() {
									editor.insertContent('<span> {{assessment_score}}</span>');
								}
							}
						];
						editor.ui.registry.addMenuButton('mybutton', {
							text: 'Merge Tags',
							fetch: function(callback) {
								callback(items);
							}
						});
					}
				}}
			/>
			<button
				type="button"
				id="new-user"
				className="btn btn-primary mt-3 mx-auto"
				onClick={handleSave}
			>
				{props.userTemplateRequest === 'add' ? (
					`Create ${props.thingBeingCreated}`
				) : props.userTemplateRequest === 'edit' ? (
					'Save changes'
				) : (
					'Not supported'
				)}
			</button>
		</div>
	);
}
